import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthPageLayout, useAuth } from '@ekhodealer/ekho-common/auth-client';
import { Button, Stack, Text } from '@ekhodealer/ekho-common/rev';

export function NoAccessPage() {
	const { signOut } = useAuth();
	const navigate = useNavigate();

	const handleSignOut = useCallback(async () => {
		await signOut();
		navigate('/login', { replace: true });
	}, [signOut, navigate]);

	return (
		<AuthPageLayout showEkhoLogo={false} showRightPanel={false}>
			<Stack itemsSpacing="24">
				<Stack itemsSpacing="12">
					<Text size="display100" weight="bold">
						No access
					</Text>
					<Text size="body" color="secondary">
						You don&apos;t currently have access to the Admin Portal.
					</Text>
					<Text size="body" color="secondary">
						If you&apos;re a dealer or OEM, check your email for an invitation to set
						up your individual account.
					</Text>
				</Stack>
				<Button variant="secondary" onPress={() => handleSignOut()}>
					Go to login
				</Button>
			</Stack>
		</AuthPageLayout>
	);
}

export default NoAccessPage;
